"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FOUNDATION_STRATEGIST_TEMPLATES = exports.FOUNDATION_STRATEGIST_TEMPLATES_MD = void 0;
exports.FOUNDATION_STRATEGIST_TEMPLATES_MD = {
    'Initial Strategy Meeting (ISM)': `* Introductions\n
* Overview of application process\n
* Answer all initial questions\n
* Academics discussion\n
* Personal Development discussion\n
* Super-Curriculars discussion\n
* Subject Interest Development discussion\n
* Initial Majors, Careers, Schools discussion\n
* Next steps and homework setting`,
    'Pathfinder Meeting': `* Review Pathfinder and mark off achieved goals\n
* Establish 3-5 new goals\n
* Establish expectations around Pathfinder use during strategy\n
* Outline short-term (now to 3 months), mid-term (3-6 months), and long-term (6+ months) goals\n
* Review common/expected deadlines (eg. key deadlines for schools of interest)\n
* Other Check-in Items`,
    'App Year Meeting': '* N/A',
    'AY: Submission Meeting': `* Application Portal Review and Proof-Reading\n
* Essay Final Formatting\n
* Submission Timeline
  `,
    'AY: Post-All-Offers Meeting': `* Discussion of all Admission Outcomes\n
* Final Choices\n
* Other Crimson Opportunities\n
  `,
    'AY: Final Meeting Before Contract End': `* Final Questions and Guidance Needed\n
* Other Crimson Opportunities\n
* Good Luck and Stay in Touch!\n
  `,
    Other: '* N/A',
};
exports.FOUNDATION_STRATEGIST_TEMPLATES = {
    'Initial Strategy Meeting (ISM)': [
        {
            listStart: 1,
            type: 'p',
            children: [
                {
                    text: 'Introductions',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 2,
            type: 'p',
            children: [
                {
                    text: 'Overview of application process',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 3,
            type: 'p',
            children: [
                {
                    text: 'Answer all initial questions',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 4,
            type: 'p',
            children: [
                {
                    text: 'Academics discussion',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 5,
            type: 'p',
            children: [
                {
                    text: 'Personal Development discussion',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 6,
            type: 'p',
            children: [
                {
                    text: 'Super-Curriculars discussion',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 7,
            type: 'p',
            children: [
                {
                    text: 'Subject Interest Development discussion',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 8,
            type: 'p',
            children: [
                {
                    text: 'Initial Majors, Careers, Schools discussion',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 9,
            type: 'p',
            children: [
                {
                    text: 'Next steps and homework setting',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
    ],
    'Pathfinder Meeting': [
        {
            listStart: 1,
            type: 'p',
            children: [
                {
                    text: 'Review Roadmap and Ensure Student Knows How it Works',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 2,
            type: 'p',
            children: [
                {
                    text: 'Establish 3-5 Immediate New Goals to Add to the Roadamap',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 3,
            type: 'p',
            children: [
                {
                    text: 'Establish Expectations of How the Roadmap and Student Centre Will Be Used Throughout Strategy',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 4,
            type: 'p',
            children: [
                {
                    text: 'Outline short-term (now to 3 months), mid-term (3-6 months), and long-term (6+ months) goals',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 5,
            type: 'p',
            children: [
                {
                    text: 'Review common/expected deadlines (eg. key deadlines for schools of interest)',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 6,
            type: 'p',
            children: [
                {
                    text: 'Other Check-in Items',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
    ],
    'App Year Meeting': [
        {
            listStart: 1,
            type: 'p',
            children: [
                {
                    text: 'N/A',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
    ],
    'AY: Submission Meeting': [
        {
            listStart: 1,
            type: 'p',
            children: [
                {
                    text: 'Application Portal Review and Proof-Reading',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 2,
            type: 'p',
            children: [
                {
                    text: 'Essay Final Formatting',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 3,
            type: 'p',
            children: [
                {
                    text: 'Submission Timeline',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
    ],
    'AY: Post-All-Offers Meeting': [
        {
            listStart: 1,
            type: 'p',
            children: [
                {
                    text: 'Discussion of all Admission Outcomes',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 2,
            type: 'p',
            children: [
                {
                    text: 'Final Choices',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 3,
            type: 'p',
            children: [
                {
                    text: 'Other Crimson Opportunities',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
    ],
    'AY: Final Meeting Before Contract End': [
        {
            listStart: 1,
            type: 'p',
            children: [
                {
                    text: 'Final Questions and Guidance Needed',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 2,
            type: 'p',
            children: [
                {
                    text: 'Other Crimson Opportunities',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 3,
            type: 'p',
            children: [
                {
                    text: 'Good Luck and Stay in Touch!',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
    ],
    Other: [
        {
            listStart: 1,
            type: 'p',
            children: [
                {
                    text: 'N/A',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
    ],
};
//# sourceMappingURL=foundations-strategist.js.map